import React, { Dispatch, SetStateAction, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { useTranslation } from 'react-i18next';
import { IAudienceCharts } from '../../../offer/dto/IAudienceCharts';
import { IAudienceDataModal } from '../../../offer/dto/IAudienceDataModal';
import { IExternalFeed } from '../../dto/IExternalSearchProfile';
import { AudienceCharts } from '../../../offer/modal/tabs/audience/AudienceCharts';
import { ExternalProfileContentTab } from './ExternalProfileContentTab';
import AudienceData from '../../../offer/modal/tabs/audience/AudienceData';
import { ExternalProfileCollaborationsTab } from './ExternalProfileCollaborationsTab';
import { ICollaboration } from '../../../../../../../model/shared/ICollaboration';
import { scrollToTopRef } from '../../../../../../../utils/helpers/ScrollToTop';

interface IExternalSearchModalTabsProps {
    charts: IAudienceCharts;
    audienceData?: IAudienceDataModal;
    feed?: IExternalFeed[];
    about?: string;
    modashData?: any;
    collaboration: ICollaboration;
    activeTab: string;
    setActiveTab: Dispatch<SetStateAction<string>>;
}

export function ExternalSearchModalTabs({
    charts,
    feed,
    audienceData,
    about,
    modashData,
    collaboration,
    setActiveTab,
    activeTab,
}: IExternalSearchModalTabsProps) {
    const { t } = useTranslation();
    const isMobile = window.innerWidth <= 700;
    const modalRef = useRef<HTMLDivElement>();

    const handleTab = (event: React.SyntheticEvent, newValue: string) => {
        setActiveTab(newValue);
        scrollToTopRef(modalRef);
    };

    return (
        <TabContext value={activeTab}>
            <Box className="mb-3">
                <TabList
                    allowScrollButtonsMobile={isMobile}
                    variant={isMobile ? 'scrollable' : 'fullWidth'}
                    onChange={handleTab}
                >
                    <Tab label={t('brand.campaign.book.offer.modal.audience')} value="audience" />
                    {feed?.length && <Tab label={t('brand.campaign.book.offer.modal.content')} value="content" />}
                    {!!collaboration && (
                        <Tab label={t('brand.campaign.book.external_search.collaborations')} value="collaboration" />
                    )}
                </TabList>
            </Box>
            <Box ref={modalRef} className="modal-right-content px-md-3">
                <TabPanel className="p-0" value="audience">
                    <AudienceData audienceData={audienceData?.platformDataArray?.[0]} />
                    <AudienceCharts charts={charts} chartDates={audienceData?.chartDates ?? []} />
                </TabPanel>
                {feed?.length ?? 0 >= 1 ? (
                    <TabPanel className="p-0" value="content">
                        <ExternalProfileContentTab feed={feed} about={about} externalImageData={modashData} />
                    </TabPanel>
                ) : null}
                {!!collaboration ? (
                    <TabPanel className="p-0" value="collaboration">
                        <ExternalProfileCollaborationsTab collaborations={collaboration} />
                    </TabPanel>
                ) : null}
            </Box>
        </TabContext>
    );
}
